import { MenuItem, Select } from "@material-ui/core";
import React, { Component } from "react";
import styled from "styled-components";

import { LibraryView } from "common/constants";
import { ActionPermissionsObject } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import { app } from "js/namespaces";
import { Divider } from "js/react/components/UiComponents";

const MyPresentationsTitle = styled.div`
    padding: 10px;
    font-size: 16px;
    color: #000;
    border: none;
    cursor: pointer;
    background: transparent;
    font-weight: 600;
    font-family: "Source Sans Pro";
    text-transform: uppercase;
`;

export class PresentationLibraryViewSelect extends Component {
    render() {
        const { libraryView, onSwitchType, isMyPresentationsOnly } = this.props;

        const canManageSharedSlides = !app.integrator && WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage;

        return (
            <>
                {isMyPresentationsOnly ? (
                    <MyPresentationsTitle>My Presentations</MyPresentationsTitle>
                ) : (
                    <Select id="libraryType" value={libraryView} onChange={event => onSwitchType(event.target.value)}
                        disableUnderline>
                        <MenuItem value={LibraryView.LIBRARY}>My Presentations</MenuItem>
                        <MenuItem value={LibraryView.MY_RESOURCES}>My Resources</MenuItem>
                        {canManageSharedSlides && <MenuItem value={LibraryView.TEAM_RESOURCES}>Team Resources</MenuItem>}
                    </Select>
                )}
                <Divider margin={10} />
            </>
        );
    }
}
